import AdminApi from "../services/api";
import Loc from "../services/localization";

/* init */
const AdminApiService = new AdminApi()
const LocService = new Loc()
import  Plyr  from 'vue-plyr';
import swal from "sweetalert2";
import CustomCalendar from "../components/Shared/CustomCalendar";
import {ref} from "vue";

export default {

    props: ['show', 'item'],

    data() {
        return {
            locale: LocService,
            selectedItem: null,
            isVisibleCalendar: false,
            title: '',
            subTitle: '',
            selectedDates: [],
            isLoading: false

        };
    },

    watch: {
        show: function (val, oldVal) {
            if (val) {
                this.isVisibleCalendar = true;
                this.selectedItem = this.item
                this.title = this.item.date
                this.subTitle = this.getDayOfWeek(this.item.date)
            }
        },
        selectedDates: function (newVal){
            console.log(newVal);
        }
    },
    components: {
        CustomCalendar
    },
    methods: {
        close() {
            this.clear();
            this.$topnavbar.$emit('closeCopyTraining')
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile() {
            if (this.isMobile()) {
                return 'modal--medium'
            } else {
                return 'modal--medium'
            }
        },
        modalStyle() {
            if (this.isMobile()) {
                return 'color: white; background-color: #1C242D;'
            } else {
                return ''
            }
        },
        mainDivStyle() {
            if (this.isMobile()) {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            } else {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }
        },
        tableStyle() {
            if (this.isMobile()) {
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        },
        getDayOfWeek: getDayOfWeek,
        setNewList: setNewList,
        save: save,
        clear: clear,
    },
}

function clear(){
    this.selectedDates = [];
    this.isVisibleCalendar = false;
}

function setNewList(items){
    this.selectedDates = items;
}

function getDayOfWeek(dateString) {
    const [day, month, year] = dateString.split("-").map(Number);

    const date = new Date(year, month - 1, day);

    const daysOfWeek = [
        LocService.t('day_sunday'),
        LocService.t('day_monday'),
        LocService.t('day_tuesday'),
        LocService.t('day_wednesday'),
        LocService.t('day_thursday'),
        LocService.t('day_friday'),
        LocService.t('day_saturday')];

    // Dohvatanje dana u nedelji i ispis
    return daysOfWeek[date.getDay()];
}


function save() {
    let _self = this;
    let ids = this.selectedItem.details.map(m => m.id)
    console.log(ids)
    let request = {
        ids: ids,
        dates: this.selectedDates
    }
    this.isLoading = true;
    AdminApiService.copyTrainingOfTheDayForDates(request)
        .then((response) => {
            _self.isLoading = false;
            swal(LocService.t("label_success"), LocService.t("label_success_update_waiting_list"), 'success')
            _self.clear();
            _self.$topnavbar.$emit('successCopyTraining')
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/modals/CopyTrainingOfTheDayForDatesModal.js